<template lang="html">
	<div>
		<onboarding-checklist
			v-if="showOnboardingChecklist"
			:tour="currentTour"
			:step-index="currentStepIndex"
			@stop-onboarding="onForceStopOnboarding"
			@continuate-onboarding="onContinuateOnboarding"
		/>

		<modal modal-content-class="w-50" :show="true" @close="skipOnboarding()" v-if="currentStep && currentStep.type === 'modal'">
			<template slot="header">
				<h3 class="modal-title bold text-center">
					{{ currentStep.name }}
				</h3>
			</template>

			<div class="label text-center" v-html="currentStep.body"></div>

			<template slot="footer">
				<div class="center w-100 row buttons">
					<div class="btn btn-gold" @click="skipOnboarding">
						<span>Passer le tutoriel</span>
					</div>
					<div class="btn btn-red" @click="onStepButtonClick" v-if="currentStep.button_name">
						<span>{{ currentStep.button_name }}</span>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<script>
import {mapGetters} from 'vuex'
import Driver from 'driver.js'
import emma from '@/common/services/Emma'
import RuleChecker from './RuleChecker/RuleChecker'
import Modal from '../Modal'
import OnboardingChecklist from './OnboardingChecklist'

export default {
	components: {OnboardingChecklist, Modal},
	data () {
		return {
			driver: null,
			tours: [],
			currentTour: null,
			lastEvent: null,
			currentStepIndex: 0,
			ruleChecker: null,
			enableCurrentStep: false,
			showOnboardingChecklist: false
		}
	},
	mounted () {
		this.ruleChecker = new RuleChecker(this.user)

		this.driver = new Driver({
			animation: true,
			opacity: 0.4,
			closeBtnText: 'Fermer',
			nextBtnText: 'Suivant →',
			prevBtnText: 'Précédent',
			allowClose: false,
			onNext: () => {
				console.log('onNext')
				this.onStepButtonClick()
			},
			onReset: () => {
				console.log('onReset')
			}
		})

		window.$(document).on('click', '.highlight-action-btn.next', () => {
			console.log('highlightActionBtnSelector')
			this.onStepButtonClick()
		})

		window.$(document).on('click', '.highlight-action-btn.close', () => {
			this.skipOnboarding()
			this.driver.reset(true)
		})

		this.loadCurrentOnboarding()
	},
	methods: {
		loadCurrentOnboarding () {
			emma.get('api/onboarding/current').then((result) => {
				if (result.data.current_tour) {
					this.initializeCurrentOnboardingTour(result.data)
				} else {
					this.loadAllOnboarding()
				}
			}).catch(() => {
				this.tours = []
				this.currentTour = null
				this.currentStepIndex = 0
			})
		},

		loadAllOnboarding () {
			emma.get('api/onboarding').then((result) => {
				this.tours = result.data.tours
				this.initializeOnboardingTour()
			}).catch(() => {
				this.tours = []
			})
		},

		addEvent (eventType, tourId, stepId) {
			let data = {
				event_type: eventType,
				tour_id: tourId,
				step_id: stepId
			}

			return emma.post('api/onboarding/event', data)
		},

		initializeCurrentOnboardingTour (data) {
			this.tours = [data.current_tour]
			this.currentTour = data.current_tour
			this.lastEvent = data.last_event
			this.currentStepIndex = this.currentTour ? data.current_step.position : 0

			if (this.lastEvent && this.lastEvent.event_type === 'tour_paused') {
				this.enableCurrentStep = false
				this.showOnboardingChecklist = this.checkCurrentStepRules()
			} else {
				this.enableCurrentStep = this.checkCurrentStepRules()

				this.handleCurrentStep()
			}
		},

		checkCurrentStepRules () {
			if (!this.currentTour ||
				typeof this.currentTour.steps[this.currentStepIndex] === 'undefined') {
				return false
			}

			return this.checkStepRules(this.currentTour.steps[this.currentStepIndex])
		},

		checkStepRules (step) {
			if (!step) {
				return false
			}

			return this.ruleChecker.check(step.rules)
		},

		initializeOnboardingTour () {
			this.currentTour = this.getCurrentTour()

			if (!this.currentTour) {
				return
			}

			this.startCurrentTour()
		},

		getCurrentTour () {
			for (let index in this.tours) {
				let found = this.checkStepRules(this.tours[index].steps[0])
				// let found = (new UrlMatchRule()).check('endsWith', this.tours[index].url_match)
				if (found) {
					return this.tours[index]
				}
			}

			return null
		},

		startCurrentTour () {
			this.currentStepIndex = 0
			let currentStepId = this.currentTour.steps[this.currentStepIndex].id
			this.enableCurrentStep = this.checkCurrentStepRules()

			this.addEvent('tour_started', this.currentTour.id, currentStepId).then(() => this.handleCurrentStep())
		},

		skipOnboarding () {
			let currentStepId = this.currentTour.steps[this.currentStepIndex].id

			this.addEvent('tour_paused', this.currentTour.id, currentStepId)

			this.enableCurrentStep = false
			this.showOnboardingChecklist = this.checkCurrentStepRules()
		},

		onStepButtonClick () {
			if (!this.currentTour) {
				return
			}

			console.log('onStepButtonClick')

			if (this.currentStep.button_type === 'redirect_url') {
				this.applyStepUrlRedirection()
				return
			}

			if (this.currentStepIndex + 1 >= this.currentTour.steps.length) {
				this.finishTour()
				return
			}

			console.log('onStepButtonClick 1')

			if (!this.ruleChecker.check(this.currentTour.steps[this.currentStepIndex + 1].rules)) {
				return
			}

			console.log('onStepButtonClick 2')

			this.increaseStep().then(() => {
				this.handleCurrentStep()
			})
		},

		applyStepUrlRedirection () {
			console.log('applyStepUrlRedirection')

			let url = this.currentStep.button_url

			console.log('applyStepUrlRedirection 2')

			this.increaseStep().then(() => {
				console.log('applyStepUrlRedirection 3')
				location.href = url
			})
		},

		increaseStep () {
			if (this.currentStepIndex + 1 >= this.currentTour.steps.length) {
				return this.finishTour()
			}

			this.currentStepIndex++

			let currentStepId = this.currentTour.steps[this.currentStepIndex].id
			this.enableCurrentStep = this.checkCurrentStepRules()

			return this.addEvent('tour_advanced', this.currentTour.id, currentStepId)
		},

		handleCurrentStep () {
			if (!this.currentStep) {
				return
			}

			if (this.driver.hasHighlightedElement()) {
				this.driver.reset(true)
			}

			if (this.currentStep.type === 'highlight') {
				this.handleHighlightStep()
			}
		},

		handleHighlightStep () {
			this.driver.highlight(this.getHighlightStepDefinition(this.currentTour.steps[this.currentStepIndex]))
			this.listenOnHighlightAreaClick()
		},

		getHighlightStepDefinition (step) {
			let popover = {
				doneBtnText: 'Terminer',
				closeBtnText: 'Fermer',
				nextBtnText: 'Suivant →',
				prevBtnText: 'Précédent',
				allowClose: false
			}

			if (step.name) {
				popover.title = step.name
			}
			if (step.body) {
				popover.description = step.body
			}

			if (step.button_name) {
				if (this.isLastStep) {
					popover.description += `<div class="highlight-action-area">
						<button class="highlight-action-btn next">${step.button_name}</button>
</div>`
				} else {
					popover.description += `<div class="highlight-action-area">
						<button class="highlight-action-btn close">Fermer</button>
						<button class="highlight-action-btn next">${step.button_name}</button>
</div>`
				}
			} else {
				popover.description += `<div class="highlight-action-area">
						<button class="highlight-action-btn close">Fermer</button>
						</div>`
			}

			popover.showButtons = false

			return {
				element: step.element_selector,
				popover: popover
			}
		},

		listenOnHighlightAreaClick () {
			if (!this.driver.hasHighlightedElement()) {
				return
			}

			document.querySelector('.driver-highlighted-element').addEventListener('click', (event) => this.handleOnHighlightClick())
		},

		handleOnHighlightClick () {
			if (this.currentStep && this.currentStep.button_type && !this.currentStep.button_name) {
				if (this.currentStepIndex + 1 >= this.currentTour.steps.length) {
					setTimeout(() => this.finishTour(), 5000)
					return
				}

				this.onStepButtonClick()
			}
		},

		finishTour () {
			let currentStepId = this.currentTour.steps[this.currentStepIndex].id
			let currentTourId = this.currentTour.id

			this.currentTour = null
			this.enableCurrentStep = false
			this.driver.reset(true)

			return this.addEvent('tour_completed', currentTourId, currentStepId)
		},

		onForceStopOnboarding () {
			this.showOnboardingChecklist = false

			let currentStepId = this.currentTour.steps[this.currentStepIndex].id

			this.addEvent('tour_stopped', this.currentTour.id, currentStepId)

			this.enableCurrentStep = false
		},

		onContinuateOnboarding () {
			this.showOnboardingChecklist = false
			this.enableCurrentStep = this.checkCurrentStepRules()

			this.handleCurrentStep()
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		}),

		currentStep () {
			return this.enableCurrentStep && this.currentTour ? this.currentTour.steps[this.currentStepIndex] : null
		},

		isLastStep () {
			return this.currentTour && this.currentTour.steps.length <= this.currentStepIndex + 1
		}

	},

	watch: {
		$route (to, from) {
			if (!this.enableCurrentStep) {
				this.loadCurrentOnboarding()
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/common/components/Onboarding/Onboarding.vue